module.exports = __webpack_public_path__ + "img/top6.6e8ebaf6.png";